import { COLORS } from '~/themes/common'

const style = (theme) => ({
  root: {
    '& .MuiOutlinedInput-root': {
      '& fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(0, 0, 0, 0.23)',
        borderWidth: '1px',
      },
    },

    '& input.MuiInputBase-input': {
      paddingRight: 0,
    },
  },

  open: {
    '& .MuiOutlinedInput-root': {
      '& fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: COLORS.palette.primaryBlue,
        borderWidth: '2px',
      },
    },
  },

  icon: {
    padding: 3,
    pointerEvents: 'none',
    marginLeft: theme.spacing(0.5),
  },

  iconClear: {
    padding: 10,
    pointerEvents: 'all',
    borderRadius: '50%',
  },

  counter: {
    color: COLORS.accent.viridianGreen1,
    fontSize: 14,
    marginLeft: theme.spacing(0.5),
  },

  inputBaseRoot: {
    cursor: 'pointer',
  },

  inputBaseInput: {
    textAlign: 'left',
  },
  tooltip: {
    background: COLORS.gray.textGray3,
    color: COLORS.palette.white,
    fontSize: 14,
    fontWeight: 300,
    padding: 16,
    borderRadius: 8,
  },
})

export default style
